module.exports = __webpack_public_path__ + "media/application/images/icons/topics-action-pebble-dark-green-rgb-4c59ea583465029a4a56dc347e950df6.svg";